// TODO: Use CardMedia instead div when the images are provided

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, CardActions, CardContent, CardMedia, Card, withWidth} from '@material-ui/core';
import {isWidthUp} from '@material-ui/core/withWidth';
import {Fade} from 'react-reveal';

const path = "/images/map.svg";
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing.unit * 12,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  teamContainer: {
    paddingTop: theme.spacing.unit * 12,
    paddingLeft: theme.spacing.unit * 3,
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing.unit * 8,
      paddingLeft: theme.spacing.unit,
    }
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    // paddingBottom: theme.spacing.unit * 2
  },
  image: {
    background: `url(${path}) no-repeat center`,
    minHeight: 450,
    minWidth: 1300,
    maxWidth: 1300,
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.down('md')]: {
      minHeight: 500,
      maxWidth: 700,
      minWidth: 600
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 500,
      maxWidth: 500,
      minWidth: 500
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: 300,
      maxWidth: 300,
      minWidth: 300
    }
  },
  dummyImage: {
    height: 50,
    width: 50,
    border: `1px solid ${theme.palette.secondary.main}`
  },
  bottomTextContainer: {
    paddingTop: theme.spacing.unit * 6
  },
  card: {
    backgroundColor: theme.palette.text.primary,
    padding: theme.spacing.unit * 4,
    paddingTop: theme.spacing.unit,
    height: '100%'
  },
  teamCard: {
    backgroundColor: theme.palette.text.primary,
    padding: theme.spacing.unit * 4,
    height: '100%'
  },
  secondRowTeamCard: {
    backgroundColor: theme.palette.text.primary,
    padding: theme.spacing.unit * 2,
    height: '100%'
  },
  media: {
    maxWidth: '100%',
    // marginBottom: theme.spacing.unit * 2
  },
  avatar: {
    height: 100,
    width: 100,
    margin: 'auto',
    marginBottom: theme.spacing.unit * 2,
    borderRadius: '50%'
  },
  description: {
    color: theme.palette.text.secondary,
  },
  bottomDescription: {
    color: theme.palette.text.secondary
  },
  cardsContainer: {
    paddingTop: theme.spacing.unit * 3
  },
  icon: {
    height: 30,
    widht: 30
  }
});

const ScalabilityAndTeam = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    {/* Scalability */}
    <Grid container direction="column" justify="space-evenly" alignItems="center">
      <Fade bottom duration={1500} distance="100px">
        <Grid item>
          <Typography variant="caption" gutterBottom className={classes.tagLine}>
            Scalability
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} align="center" gutterBottom color="inherit">
            Coming to a FIAT market,
            <div style={{fontWeight: 'bold'}}> near you!</div>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" className={classes.description}>
            Our endeavour is to provide decentralized financial tools for the entire globe. As time progresses, we will
            be
            expanding our reach and adding more options for users across the world to directly access CryptX financial
            through their national sovereign currency.
          </Typography>
        </Grid>
        <Grid item>
          <div className={classes.image}/>
        </Grid>
        <Grid item>
          <Grid container direction="row" justify="center" alignItems="stretch" spacing={24}>
            <Grid item xs sm={6} lg={3}>
              <Card className={classes.card}>
                <CardContent>
                  <img
                    src="/images/icons/maps/malaysia.svg"
                    className={classes.media}
                    title="Map"
                  />
                  <Typography gutterBottom variant="body1" color="inherit">
                    Malaysia
                  </Typography>
                  <Typography variant="caption" className={classes.bottomDescription}>Work in Progress</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs sm={6} lg={3}>
              <Card className={classes.card}>
                <CardContent>
                  <img
                    src="/images/icons/maps/africa.svg"
                    className={classes.media}
                    title="Map"
                  />
                  <div className={classes.media}/>
                  <Typography gutterBottom variant="body1" color="inherit">
                    Republic of Central Africa
                  </Typography>
                  <Typography variant="caption" className={classes.bottomDescription}>Work in Progress</Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs sm={6} lg={3}>
              <Card className={classes.card}>
                <CardContent>
                  <img
                    src="/images/icons/maps/canada.svg"
                    className={classes.media}
                    title="Map"
                  />
                  <div className={classes.media}/>
                  <Typography gutterBottom variant="body1" color="inherit">
                    Canada
                  </Typography>
                  <Typography variant="caption" className={classes.bottomDescription}>Planned (2020) </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs sm={6} lg={3}>
              <Card className={classes.card}>
                <CardContent>
                  <img
                    src="/images/icons/maps/australia.svg"
                    className={classes.media}
                    title="Map"
                  />
                  <div className={classes.media}/>
                  <Typography gutterBottom variant="body1" color="inherit">Australia</Typography>
                  <Typography variant="caption" className={classes.bottomDescription}>Planned (2020)</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
    {/* Team */}
    <Grid container direction="column" justify="space-evenly" alignItems="center" className={classes.teamContainer}>
      <Fade bottom duration={1500} distance="100px">
        <Grid item>
          <Typography variant="caption" gutterBottom className={classes.tagLine}>
            The Leadership Team
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} color="inherit" gutterBottom>
            Meet <span style={{fontWeight: 'bold'}}> our Core Team.</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="inherit" className={classes.bottomDescription}>
            You can visit our “Team Page” to see our entire team structure.
          </Typography>
        </Grid>
        {/* Team Cards */}
        <Grid item>
          {/* First row */}
          <Grid container direction="row" justify="center" alignItems="stretch" spacing={24}
                className={classes.cardsContainer}>
            <Grid item xs={12} sm={6} md={4}>
              <Card className={classes.teamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center">
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" justify="space-between" alignItems="center">
                        <Grid item>
                          <CardMedia
                            className={classes.avatar}
                            image="/images/team/akshay-nair.png"
                            title="Team Member"
                          />
                        </Grid>
                        <Grid item>
                          <Typography gutterBottom variant="body1" color="inherit">
                            Akshay Nair
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="caption" className={classes.description}>
                            Founder & Chief Executive
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <CardActions>
                      <div>
                        <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                      </div>
                    </CardActions>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Card className={classes.teamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center">
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" justify="space-between" alignItems="center">
                        <Grid item>
                          <CardMedia
                            className={classes.avatar}
                            image="/images/team/shiva-gurunathan.jpg"
                            title="Team Member"
                          />
                        </Grid>
                        <Grid item>
                          <Typography gutterBottom variant="body1" color="inherit">
                            Sivagurunath Sivanesan
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="caption" className={classes.description}>
                            Co Founder & Chief Technology Officer
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <CardActions>
                      <div>
                        <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                      </div>
                    </CardActions>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
          {/* Second row */}
          <Grid container alignItems="stretch"
                justify="center"
                className={classes.cardsContainer} spacing={16}>
            <Grid item xs>
              <Card className={classes.secondRowTeamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center" style={{height: '100%'}}>
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" alignItems="center">
                        <CardMedia
                          className={classes.avatar}
                          image="/images/team/mauro-andriotto.jpg"
                          title="Team Member"
                        />
                        <Typography align="center" gutterBottom variant="body1" color="inherit">Mauro Andriotto</Typography>
                        <Typography align="center" variant="caption" className={classes.description}>Advisor - Finance and
                          Securities</Typography>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs>
              <Card className={classes.secondRowTeamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center" style={{height: '100%'}}>
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" alignItems="center">
                        <CardMedia
                          className={classes.avatar}
                          image="/images/team/nicholas-martin.jpeg"
                          title="Team Member"
                        />
                        <Typography align="center" gutterBottom variant="body1" color="inherit">Nicholas Martin</Typography>
                        <Typography align="center" variant="caption" className={classes.description}>Advisor - Legal and
                          Compliance</Typography>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs>
              <Card className={classes.secondRowTeamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center" style={{height: '100%'}}>
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" alignItems="center">
                        <CardMedia
                          className={classes.avatar}
                          image="/images/team/richard-shibi.jpg"
                          title="Team Member"
                        />
                        <Typography align="center" gutterBottom variant="body1" color="inherit">Richard Shibi</Typography>
                        <Typography align="center" variant="caption" className={classes.description}>Advisor - European
                          Market </Typography>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs>
              <Card className={classes.secondRowTeamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center" style={{height: '100%'}}>
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" alignItems="center">
                        <CardMedia
                          className={classes.avatar}
                          image="/images/team/therry-cabou.jpg"
                          title="Team Member"
                        />
                        <Typography align="center" gutterBottom variant="body1" color="inherit">Thierry Cabou</Typography>
                        <Typography align="center" variant="caption" className={classes.description}>Advisor - African
                          Market</Typography>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
            <Grid item xs>
              <Card className={classes.secondRowTeamCard}>
                <Grid container direction="column" justify="space-between" alignItems="center" style={{height: '100%'}}>
                  <Grid item>
                    <CardContent>
                      <Grid container direction="column" alignItems="center">
                        <CardMedia
                          className={classes.avatar}
                          image="/images/team/kyle-white.jpg"
                          title="Team Member"
                        />
                        <Typography align="center" gutterBottom variant="body1" color="inherit">Kyle White</Typography>
                        <Typography align="center" variant="caption" className={classes.description}>Advisor - American
                          Market </Typography>
                      </Grid>
                    </CardContent>
                  </Grid>
                  <Grid item>
                    <img src="/images/icons/social/linkedin.svg" alt="Linkedin" className={classes.icon}/>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Grid>
  </div>
));

export default withWidth()(ScalabilityAndTeam);
